import styled from 'styled-components'

const Container = styled.div<{ $portrait?: boolean }>`
  position: absolute;
  bottom: ${({ $portrait }) => ($portrait ? '13px' : '6px')};
  left: 0;
  right: 0;
  margin: auto;
  width: 75px;
  height: 30px;
  overflow: hidden;
  z-index: 2;
`

const DotList = styled.ul<{ $indexOffset: number }>`
  list-style: none;
  position: absolute;
  padding: 0;
  margin: 0;
  width: 120px;
  left: 50%;
  top: 50%;
  transform: ${({ $indexOffset }) =>
    `translate(-${$indexOffset * 14 + 7}px, -50%)`};
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  transition: transform 200ms linear;
`

const Dot = styled.button.attrs({ type: 'button' })<{ $active: boolean }>`
  appearance: none;
  border: none;
  padding: 0;
  margin: 0 3px;
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: white;
  opacity: ${({ $active }) => ($active ? 1 : 0.6)};
  transform: ${({ $active }) => ($active ? 'scale(1.25)' : 'scale(1)')};
  transition: opacity 200ms ease, transform 200ms ease;
  cursor: pointer;
`

type ScrollingDotsProps = {
  activeIndex: number
  totalSlides: number
  onDotClick?: (index: number) => void
  portrait?: boolean
}

const ScrollingDots = ({
  activeIndex,
  totalSlides,
  onDotClick,
  portrait,
}: ScrollingDotsProps) => {
  if (totalSlides <= 1) return null

  return (
    <Container $portrait={portrait}>
      <DotList $indexOffset={activeIndex}>
        {Array.from({ length: totalSlides }, (_, index) => (
          <li key={index}>
            <Dot
              $active={index === activeIndex}
              onClick={() => onDotClick?.(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          </li>
        ))}
      </DotList>
    </Container>
  )
}

export default ScrollingDots
